<DOMContainer
    width="100%"
    height="100%"
    zIndex={100}
    class="notification"
    style="pointer-events: none !important;"
>
    <div class="rpg-ui-notifications">
        @for ((notif,index) of notifications) {
            <div
                class="rpg-ui-notification"
                data-type={notif.type || "info"}
                style={notificationStyle(notif)}
            >
                @if (notif.icon) {
                    <div class="rpg-ui-notification-icon">
                        <DOMSprite sheet={iconSheet(notif.icon)} />
                    </div>
                }
                <div class="rpg-ui-notification-message">{notif.message}</div>
            </div>
        }
    </div>
</DOMContainer>

<style>
    .notification {
        pointer-events: none !important;
    }
</style>

<script>
    import { effect, computed } from "canvasengine";
    import { inject } from "../../../core/inject";
    import { RpgClientEngine } from "../../../RpgClientEngine";

    const engine = inject(RpgClientEngine);
    const notifications = computed(() => engine.notificationManager.stack());

    const iconSheet = (iconId) => ({
        definition: engine.getSpriteSheet(iconId),
        playing: "default"
    });

    effect(() => {
        const list = notifications();
        const rowHeight = 68;
        list.forEach((notif, index) => {
            notif.layoutY.set(index * rowHeight);
        });
    });

    const notificationStyle = (notif) => ({
        opacity: notif.opacity(),
        transform: `translateY(${notif.layoutY() + notif.offset()}px)`
    });
</script>
